import moment from "moment"

export const convertIntoLakh = (amount) => {
    if (amount !== "" && amount !== undefined) {
        if (amount >= 100000 && amount < 10000000) {
            const lakhAmount = amount / 100000;
            return `${Number.isInteger(lakhAmount) ? lakhAmount.toFixed(0) : lakhAmount.toFixed(1)} Lakh`;
        } else if (amount >= 10000000) {
            const croreAmount = amount / 10000000;
            return `${Number.isInteger(croreAmount) ? croreAmount.toFixed(0) : croreAmount.toFixed(1)} Cr`;
        } else if (amount >= 1000) {
            const thousandAmount = amount / 1000;
            return `${Number.isInteger(thousandAmount) ? thousandAmount.toFixed(0) : thousandAmount.toFixed(2)} Thousand`;
        }
        return amount;
    }
};

export const CommaSeprator = (input) => {
    if (input !== null && input !== undefined) {

        let value = input;
        let rupee = value.toString();
        let newRupee = rupee.substring(rupee.length - 3);
        let other = rupee.substring(0, rupee.length - 3);
        if (other !== '')
            newRupee = ',' + newRupee;
        let formatedValue = other.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + newRupee;
        return formatedValue;
    }
   // console.log(input)
};

export const CountYear = (yearVal) => {
    let today = new Date();
    today = new Date(today.setFullYear(today.getFullYear() + parseInt(yearVal)));
    let year = today.getFullYear();
    return year;
};

export const CalculateUserAge = (dob) => {
    const dobOBJ = moment(dob, 'YYYY-MM-DD');
    const today = moment();
    const age = today.diff(dobOBJ, 'years');
    return age;
}


export const TermLifeLoaderBox = [{
    id: 1,
    Image: "https://i.ibb.co/r7qJ7vp/Canera-Hsbc-Obc.png",
},
{
    id: 2,
    Image: "https://i.ibb.co/ZXrmq05/Aegon.png",
}, {
    id: 3,
    Image: "https://i.ibb.co/jrZkV4P/Future.png",
}, {
    id: 4,
    Image: "https://i.ibb.co/CB94MGj/primica.png",
}, {
    id: 5,
    Image: "https://i.ibb.co/44kgJsp/Kotak.png",
}, {
    id: 6,
    Image: "https://i.ibb.co/4jcfmRF/IciciPru.png",
},
];
export const calculateAge = (age) => {

    let CoverTillAge = []
    for (let Age = age + 5; Age <= 100; Age++) {
        CoverTillAge.push({
            value: Age,
            label: Age + " years"
        })

    }
    return CoverTillAge
}

export const AnnualIncomeArr = () => {
    let AnnualIncome = []
    for (let Amt = 2; Amt < 30; Amt++) {
        AnnualIncome.push({
            value: Amt * 100000,
            label: Amt + " Lakhs"
        })

    }
    return AnnualIncome
}

export const PayDuration = () => {
    let PayTerm = [];
    PayTerm.push({ value: 0, label: "Regular Pay" });
    PayTerm.push({ value: 1, label: "1 Year" });
    for (let Yrr = 1; Yrr <= 10; Yrr++) {
        PayTerm.push({
            value: 5 * Yrr,
            label: 5 * Yrr + " Years"
        })

    }
    return PayTerm
}

export const getUniqueCode = (length, isAlpha) => {
    return isAlpha
        ? Math.random().toString(36).toUpperCase().slice(-length)
        : new Date().getTime().toString().slice(-length);
};

export const generateLotNo = (enquiryNo, userId) => {
    const enqNo = enquiryNo?.split('/');
    const posCode =
        userId && userId != '' && userId !== 0 ? userId : getUniqueCode(5, true);
    const randomCode = getUniqueCode(5, false);
    return enqNo[2] + enqNo[3] + 'S' + posCode + 'S' + randomCode;
};


export const getAge = (dob) => {
    try {
        let today = new Date();
        let birthDate = new Date(dob);
        let age = today.getFullYear() - birthDate.getFullYear();
        let month = today.getMonth() - birthDate.getMonth();
        if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }

        return age;
    } catch (er) {
        return 0;
    }
};

export const countTrueValuesRiders = (benefitAndRiderObj) => {
    const excludeKeys = [
        'IsAccidentalDeathBenefit',
        'IsPremiumProtectionBenefit',
        'IsPremiumWaiverBenefit'
    ];
    return Object.keys(benefitAndRiderObj)
        .filter(key => !excludeKeys.includes(key))
        .map(key => benefitAndRiderObj[key])
        .filter(value => value === true)
        .length;
};

export const countTrueValuesBenefit = (benefitAndRiderObj) => {
    const includeKeys = [
        'IsAccidentalDeathBenefit',
        'IsPremiumProtectionBenefit',
        'IsPremiumWaiverBenefit'
    ];

    return Object.keys(benefitAndRiderObj)
        .filter(key => includeKeys.includes(key))
        .map(key => benefitAndRiderObj[key])
        .filter(value => value === true)
        .length;
};


/*const countTrueValuesRiders = () => {
    const excludeKeys = [
        'IsAccidentalDeathBenefit',
        'IsPremiumProtectionBenefit',
        'IsPremiumWaiverBenefit'
    ];
    return Object.keys(benefitAndRiderObj)
        .filter(key => !excludeKeys.includes(key))
        .map(key => benefitAndRiderObj[key])
        .filter(value => value === true)
        .length;
};

const countTrueValuesBenefit = () => {
    const includeKeys = [
        'IsAccidentalDeathBenefit',
        'IsPremiumProtectionBenefit',
        'IsPremiumWaiverBenefit'
    ];

    return Object.keys(benefitAndRiderObj)
        .filter(key => includeKeys.includes(key))
        .map(key => benefitAndRiderObj[key])
        .filter(value => value === true)
        .length;
};

*/
export const pinRepeatedPattern = /^(\d)\1{5}$/;

export const mobilePattern = /^(\d)\1{5}/  // /(0{6,}|1{6,}|2{6,}|3{6,}|4{6,}|5{6,}|6{6,}|7{6,}|8{6,}|9{6,})/;